// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modalbox :v-deep.el-dialog[data-v-3fe67ea3] {\n  min-width: 550px;\n}\n.container[data-v-3fe67ea3] {\n  min-width: 821px;\n}\n.dialogBox[data-v-3fe67ea3] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.dialogBox .el-pagination[data-v-3fe67ea3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 25px;\n}", ""]);
// Exports
module.exports = exports;
